import React, { Component } from 'react';
import { IntlProvider } from 'react-intl'
import { Redirect, Route, Switch } from 'react-router-dom';
import MainApp from 'app/index';
import AppLocale from '../lngProvider';
import ActivityTracker from './ActivityTracker';

export class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false
        };
    }

    render() {
        const { ready } = this.state;
        const { match } = this.props;

        if (ready === true && (window.location.pathname === '/' || window.location.pathname === '/app' || window.location.pathname === '/app/')) {
            return (<Redirect to="/app/login" />);
        }

        const preferredAppLocale = AppLocale.preferred();

        return (
            <ActivityTracker>
                <IntlProvider
                    locale={preferredAppLocale.locale}
                    messages={preferredAppLocale.messages}>
                    <div className="app-main">
                        <Switch>
                            <Route path={`${match.url}app`} component={MainApp} />
                            <Route component={() => <div>Not Found</div>} />
                        </Switch>
                    </div>
                </IntlProvider>
            </ActivityTracker>
        );
    }
}